export default __webpack_public_path__ + "static/media/iconDelete.c9684e28.svg";